<template>
  <md-card class="dialog-card">
    <div
      v-if="!disableAll && enableSave"
      class="md-layout md-alignment-center-right buttons-content"
    >
      <md-button @click="resetMarks(files)" class="md-just-icon md-info md-simple">
        <md-icon>cached</md-icon>
        <md-tooltip>Deshacer selección</md-tooltip>
      </md-button>
      <md-button
        class="md-warning"
        v-if="canAddPhotoreason"
        style="margin-left: 8px"
        :disabled="loading"
        @click="saveChanges"
      >
        <md-icon style="margin-right: 8px">save</md-icon>Eliminar fotos
      </md-button>
    </div>
    <md-card-content>
      <tabs
        :options="tabsOptions"
        :cacheLifetime="0"
        id="evidences-tabs"
        class="md-layout-item md-size-100"
        ref="tabs"
        @changed="tabChanged"
      >
        <tab
          v-for="fileType in filteredFileTypes"
          :id="fileType.id"
          :name="fileType.name"
          :key="fileType.id"
        >
          <md-button
            v-if="fileType.codename === 'BTC' && !disableAll"
            :disabled="loading || disableAll"
            @click="downloadBinnacle"
            class="md-simple md-info"
          >
            <md-icon class="md-primary">cloud_download</md-icon>
            <template v-if="!generating">Descargar formato de bitácora</template>
            <template v-else>Descargando...</template>
          </md-button>
          <KDraggableField
            v-if="fileType.type === 'image'"
            class="file-container"
            :disabled="fileType.disableCharge(files) || loading || disableAll"
            @input="handlerDraggedFile($event, fileType)"
          >
            <loading-content
              v-if="
                !files[fileType.codename] || !files[fileType.codename].length
              "
              slot="empty-state"
              class="md-accent"
              empty-icon="photo_library"
              :empty-label="`Sin archivos de ${fileType.name}`"
            />
            <Matrix v-else :images="files[fileType.codename].filter((photo) => photo.id)">
              <template slot="image-actions" slot-scope="{ image: photo }">
                <md-button
                  class="md-just-icon md-round md-info view"
                  @click.stop="$emit('openVisor', photo)"
                >
                  <md-icon>remove_red_eye</md-icon>
                  <md-tooltip>Ver archivo</md-tooltip>
                </md-button>
                <md-button
                  @click.stop="changeVisible(photo)"
                  class="md-just-icon md-round visible"
                  :disabled="
                    !canChangePhotoreason ||
                    mapReject[photo.id] ||
                    disableAll ||
                    loading
                  "
                  :style="!photo.visibleCustomer ? 'opacity: 0.85;' : ''"
                  :class="{
                    'md-plain': !mapVisible[photo.id],
                    'md-primary': mapVisible[photo.id],
                  }"
                >
                  <md-icon>people_alt</md-icon>
                  <md-tooltip class="md-primary">
                    <template v-if="!photo.visibleCustomer">
                      Presione el boton para hacer el archivo visible para el
                      cliente
                    </template>
                    <template v-else>El archivo es visible por el cliente.</template>
                  </md-tooltip>
                </md-button>
                <md-button
                  v-if="!disableAll && canDeletePhotoreason"
                  @click.stop="mapReject[photo.id] = !mapReject[photo.id]"
                  class="md-just-icon md-round reject"
                  :class="{
                    'md-danger': mapReject[photo.id],
                    'md-secondary': !mapReject[photo.id],
                  }"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip class="md-primary">Presione el boton para rechazar la foto</md-tooltip>
                </md-button>
              </template>
            </Matrix>
          </KDraggableField>
          <KDraggableField
            v-else
            class="file-container"
            :disabled="fileType.disableCharge(files) || loading || disableAll"
            @input="handlerDraggedFile($event, fileType)"
          >
            <md-card
              v-for="(file, index) of files[fileType.codename].filter(
                (file) => file.id
              )"
              :key="index"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-80">
                  <md-icon class="md-primary md-size-2x">picture_as_pdf</md-icon>
                  <md-tooltip>{{ file.name || file.file.name }}</md-tooltip>
                </div>
                <div class="md-layout-item md-size-20">
                  <div class="buttons">
                    <md-button class="md-info md-just-icon md-round" @click="showFile(file)">
                      <md-icon>remove_red_eye</md-icon>
                      <md-tooltip>Ver archivo</md-tooltip>
                    </md-button>
                    <md-button
                      @click.stop="mapVisible[file.id] = !mapVisible[file.id]"
                      class="md-just-icon md-round"
                      :disabled="
                        !canChangePhotoreason ||
                        mapReject[file.id] ||
                        disableAll ||
                        loading
                      "
                      :style="!file.visibleCustomer ? 'opacity: 0.85;' : ''"
                      :class="{
                        'md-plain': !mapVisible[file.id],
                        'md-primary': mapVisible[file.id],
                      }"
                    >
                      <md-icon>people_alt</md-icon>
                      <md-tooltip class="md-primary">
                        <template v-if="!file.clientVisibility">
                          Presione el boton para hacer el archivo visible para
                          el cliente
                        </template>
                        <template v-else>El archivo es visible por el cliente.</template>
                      </md-tooltip>
                    </md-button>
                    <md-button
                      v-if="!disableAll"
                      class="md-just-icon md-round"
                      :class="!!mapReject[file.id] ? 'md-danger' : ''"
                      @click="mapReject[file.id] = !mapReject[file.id]"
                    >
                      <md-icon>close</md-icon>
                      <md-tooltip>Rechazar archivo</md-tooltip>
                    </md-button>
                  </div>
                </div>
              </div>
              <p class="date-text md-caption" v-if="file.id">
                Subido el:
                <strong>{{ file.addDate | shortDate }}</strong>
              </p>
            </md-card>
            <loading-content
              v-if="
                !files[fileType.codename] || !files[fileType.codename].length
              "
              slot="empty-state"
              class="md-accent"
              empty-icon="picture_as_pdf"
              :empty-label="`Sin archivos de ${fileType.name}`"
            />
          </KDraggableField>
        </tab>
      </tabs>
    </md-card-content>
  </md-card>
</template>

<script>
import Matrix from "./Matrix";
import KDraggableField from "@/components/Inputs/KDraggableField";

import { cloneDeep } from "lodash";
import { readImage, writeImage, reduceImageQuality } from "@/utils";
import { mapPermissions } from "@/plugins/accountPermissions/";
import purchaseService from "@/services/purchase";

export default {
  name: "FilesTab",
  components: { Matrix, KDraggableField },
  props: {
    fileTypes: {
      type: Array,
      required: true,
      default: () => [],
    },
    loadedFiles: {
      type: Object,
      required: true,
      default: () => {},
    },
    disableAll: {
      type: Boolean,
      default: false,
    },
    casualty: {
      required: true,
    },
  },
  data() {
    return {
      currentType: null,
      loading: false,
      files: {},
      mapReject: {},
      mapVisible: {},
      currentTab: null,
      generating: false,
    };
  },
  computed: {
    ...mapPermissions("WorkPlan", "photoreason"),
    ...mapPermissions("Commons", "file"),
    filteredFileTypes() {
      const optionalTypes = ["BTC", "GO"];
      return this.fileTypes.filter(({ codename }) =>
        !this.casualty.requiredBTC
          ? !optionalTypes.includes(codename)
          : codename
      );
    },
    tabsOptions() {
      return {
        useUrlFragment: false,
        defaultTabHash: this.currentTab,
      };
    },
    markedVisible() {
      const { mapVisible, mapReject } = this;
      const toChange = [];
      const { files } = this;
      const allFiles = this.filteredFileTypes
        .map(({ codename }) => files[codename])
        .flat()
        .filter((f) => !!f && f.id);
      Object.keys(mapVisible).forEach((m) => {
        const previous = allFiles.find((f) => f.id === +m);
        if (!mapReject[m] && mapVisible[m] !== previous.visibleCustomer) {
          toChange.push({
            id: +m,
            status: mapVisible[m],
          });
        }
      });
      return toChange;
    },
    markedReject() {
      const { mapReject } = this;
      const toReject = [];
      Object.keys(mapReject).forEach((m) => {
        if (mapReject[m]) {
          toReject.push(+m);
        }
      });
      return toReject;
    },
    enableSave() {
      return this.markedReject.length;
    },
  },
  methods: {
    downloadBinnacle() {
      this.generating = true;
      purchaseService
        .downloadBinnacle(this.casualty.id)
        .then(() => {})
        .catch(this.$fireErrorResponse)
        .finally(() => (this.generating = false));
    },
    showFile({ file }) {
      if (file) {
        const win = window.open(file, "_blank");
        win.focus();
      }
    },
    handlerDraggedFile(e, type) {
      if (this.loading || type.disableCharge(this.files) || this.disableAll) {
        return;
      }
      const { singleFile } = type;
      this.currentType = type;
      this.loadFiles(singleFile ? e[0] : e);
    },
    loadFiles(e) {
      const files = e.target
        ? e.target.files || e.dataTransfer.files
        : Array.isArray(e)
        ? e
        : [e];
      this.loading = true;
      Promise.all(files.map((f) => this.uploadFiles(f)))
        .then(() => {
          const { files } = this;
          const toLoadFiles = this.filteredFileTypes
            .map(({ codename }) => files[codename])
            .flat()
            .filter((f) => !!f && !f.id);
          this.$emit("saveChanges", toLoadFiles, [], []);
        })
        .finally(() => (this.loading = false));
    },
    uploadFiles(file) {
      const promise = new Promise((resolve) => {
        const { codename, type, id, allowedFormats } = this.currentType;
        const allowFileFormats = ["pdf", "xlsx", "xls"];
        const allowImageFormats = ["jpg", "jpeg", "png"];
        const format = !!file && file.name.split(".").pop();
        if (
          type === "image"
            ? !allowImageFormats.some((f) => f === format.toLowerCase())
            : !allowFileFormats.some((f) => f === format.toLowerCase())
        ) {
          this.$alertMessage({
            title: "Algunos archivos son de formato incorrecto",
            text: `Sólo se permite: ${allowedFormats.toString()}`,
          });
          this.loading = false;
          return;
        }
        if (allowFileFormats.some((t) => t === format)) {
          this.files[codename].push({
            file,
            visibleCustomer: false,
            fileType: id,
            codename,
          });
          resolve();
        } else {
          readImage(file).then((img) => {
            reduceImageQuality(img).then((reduced) => {
              writeImage(reduced)
                .then((res) => {
                  this.files[codename].push({
                    file: res,
                    src: reduced,
                    fileType: id,
                    visibleCustomer: false,
                    codename,
                  });
                })
                .finally(() => resolve());
            });
          });
        }
      });
      return promise;
    },
    resetMarks(files) {
      const allFiles = this.filteredFileTypes
        .map(({ codename }) => files[codename])
        .flat();
      this.mapVisible = {};
      this.mapReject = {};
      if (allFiles.length && allFiles[0]) {
        let mapVisible = {};
        let mapReject = {};
        mapVisible = allFiles.reduce(
          (ac, a) => ({ ...ac, [a.id]: !!a.visibleCustomer }),
          {}
        );
        mapReject = allFiles.reduce((ac, a) => ({ ...ac, [a.id]: false }), {});
        this.mapVisible = Object.assign({}, this.mapVisible, mapVisible);
        this.mapReject = Object.assign({}, this.mapReject, mapReject);
      }
    },
    removeFile({ codename }, index) {
      this.files[codename].splice(index, 1);
    },
    changeVisible({ id }) {
      this.mapVisible[id] = !this.mapVisible[id];
      this.$emit("saveChanges", [], [], this.markedVisible);
    },
    saveChanges() {
      this.$emit("saveChanges", [], this.markedReject, []);
    },
    tabChanged({ tab }) {
      const tId = tab.id;
      this.currentTab = tId;
    },
  },
  watch: {
    loadedFiles: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.files = cloneDeep(newVal);
          this.resetMarks(newVal);
        }
      },
    },
    fileTypes(value) {
      if (value && value[0]) {
        const { codename } = value[0];
        this.currentTab = codename;
        this.$refs.tabs.selectTab(`#${codename}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.buttons-content {
  position: absolute;
  right: 10px;
  z-index: 10;
  padding: 10px;
}
.md-card-content {
  background-color: white !important;
  margin: 0;
  padding: 5px 10px;
}
.dialog-card {
  position: relative;
  z-index: 0;
  .md-card-content {
    min-height: 100%;
    background-color: rgb(238, 238, 238);
    padding-bottom: 0;
    .tabs {
      padding: 0;
    }
  }
}
.md-tooltip {
  z-index: 110;
}
.file-container {
  padding: 8px;
  display: flex;
  align-content: start;
  justify-content: start;
  flex-wrap: wrap;
  overflow: auto;
  margin: 0;
  min-height: 240px;
  .md-card {
    width: 150px;
    margin: 0 4px;
    min-height: 90px;
    div {
      height: 100%;
      div {
        height: 100%;
        display: flex;
        .buttons {
          flex-direction: column;
        }
      }
    }
    .date-text {
      margin-top: 10px;
      text-align: center;
    }
  }
}

#evidences-tabs {
  margin: 25px 0;
}
.visible {
  bottom: 20px;
}
.reject {
  bottom: -10px;
}
.view {
  bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Lifting/FilesTab.vue